import React, { useEffect, useState } from "react";
import InsightsList from "@/components/Insights/InsightsList";
import api from "@/api/Axios";
import Link from "next/link";
import FeaturedMarketInsights from "@/components/Insights/FeaturedMarketInsights";
import { BreadcrumbJsonLd } from "next-seo";
import MetaTags from "@/components/seo/meta-tags";

import { S3_BASE_URL } from "@/constastants/Constant";
const MarketInsights = () => {
  const [marketInsights, setMarketInsights] = useState([]);
  const [page, setPage] = useState(1);
  const [isDataRemaining, setIsDataRemaining] = useState();
  const getmarketInsights = async () => {
    try {
      const resp = await api.get(`/newsletter/?page=${page}&page_size=6`);
      if (resp?.data?.status == 200) {
        setMarketInsights(resp?.data?.data?.results);
        setIsDataRemaining(resp?.data?.data?.next === null ? false : true);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getmarketInsights();
  }, [page]);

  return (
    <>
      <MetaTags
        title="Market Insights"
        description="Gain a competitive edge with Elchemy's in-depth market analyses. Stay ahead in the dynamic world of chemicals with our expert insights and strategic perspectives."
        addKey="Elchemy Home Page"
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: "Home",
            item: `${process.env.NEXT_PUBLIC_APP_URL}/`,
          },
          {
            position: 2,
            name: "Market Insights",
            item: `${process.env.NEXT_PUBLIC_APP_URL}/market-insights`,
          },
        ]}
      />
      <div>
        <div className="w-full h-[45vh] md:h-[60vh] bg-slate-400 relative">
          <img
            src={`${S3_BASE_URL}/products/icons/1709543549.webp`}
            className="w-full h-full object-cover"
            alt="Market insight background image"
          />
          <div className="absolute top-0 w-full h-full flex justify-center items-center z-10 bg-[#0000007e]">
            <p className="absolute top-4 left-2 sm:top-10 sm:left-20 ">
              <Link href={"/"} className="text-[0.85rem] text-[#dfdfdf]">
                Home
              </Link>{" "}
              <span className="px-1 text-white">/</span>{" "}
              <span className="font-medium text-[0.9rem] text-white">
                Market Insights
              </span>
            </p>
            <div className="flex flex-col justify-center items-center">
              <h1 className="text-white text-[1.4rem] md:text-[3.8rem] text-center border-b-2 p-1 px-4 font-mukta font-medium">
                Elchemy’s Market <span className="font-medium">Insights</span>
              </h1>
              <p className="text-center w-[70%] text-white mt-6 font-mukta text-[1.2rem] sm:text-[1.4rem] font-medium">
                Welcome to Elchemy's Market Insights Hub, your gateway to
                industry knowledge and strategic foresight.
              </p>
            </div>
          </div>
        </div>
        <FeaturedMarketInsights />
        {marketInsights.length > 0 && (
          <InsightsList
            page={"More Insights"}
            data={marketInsights}
            type={"market insights"}
            setPage={setPage}
            pagenumber={page}
            isNext={isDataRemaining}
          />
        )}
      </div>
    </>
  );
};

export default MarketInsights;
